import AaBadgeImage from 'assets/images/Aa_badge.png';
import BbBadgeImage from 'assets/images/Bb_badge.png';
import CcBadgeImage from 'assets/images/Cc_badge.png';
import DdBadgeImage from 'assets/images/Dd_badge.png';
import EeBadgeImage from 'assets/images/Ee_badge.png';
import FfBadgeImage from 'assets/images/Ff_badge.png';
import GgBadgeImage from 'assets/images/Gg_badge.png';
import HhBadgeImage from 'assets/images/Hh_badge.png';
import IiBadgeImage from 'assets/images/Ii_badge.png';
import JjBadgeImage from 'assets/images/Jj_badge.png';
import KkBadgeImage from 'assets/images/Kk_badge.png';
import LlBadgeImage from 'assets/images/Ll_badge.png';
import MmBadgeImage from 'assets/images/Mm_badge.png';
import NnBadgeImage from 'assets/images/Nn_badge.png';
import OoBadgeImage from 'assets/images/Oo_badge.png';
import PpBadgeImage from 'assets/images/Pp_badge.png';
import QqBadgeImage from 'assets/images/Qq_badge.png';
import RrBadgeImage from 'assets/images/Rr_badge.png';
import SsBadgeImage from 'assets/images/Ss_badge.png';
import TtBadgeImage from 'assets/images/Tt_badge.png';
import UuBadgeImage from 'assets/images/Uu_badge.png';
import VvBadgeImage from 'assets/images/Vv_badge.png';
import WwBadgeImage from 'assets/images/Ww_badge.png';
import XxBadgeImage from 'assets/images/Xx_badge.png';
import YyBadgeImage from 'assets/images/Yy_badge.png';
import ZzBadgeImage from 'assets/images/Zz_badge.png';

export const LetterBookBadgeDict = {
  1: AaBadgeImage,
  2: BbBadgeImage,
  3: CcBadgeImage,
  4: DdBadgeImage,
  5: EeBadgeImage,
  6: FfBadgeImage,
  7: GgBadgeImage,
  8: HhBadgeImage,
  9: IiBadgeImage,
  10: JjBadgeImage,
  11: KkBadgeImage,
  12: LlBadgeImage,
  13: MmBadgeImage,
  14: NnBadgeImage,
  15: OoBadgeImage,
  16: PpBadgeImage,
  17: QqBadgeImage,
  18: RrBadgeImage,
  19: SsBadgeImage,
  20: TtBadgeImage,
  21: UuBadgeImage,
  22: VvBadgeImage,
  23: WwBadgeImage,
  24: XxBadgeImage,
  25: YyBadgeImage,
  26: ZzBadgeImage,
};
export const LetterBookBadgeIdToLetterDict = {
  1: 'A',
  2: 'B',
  3: 'C',
  4: 'D',
  5: 'E',
  6: 'F',
  7: 'G',
  8: 'H',
  9: 'I',
  10: 'J',
  11: 'K',
  12: 'L',
  13: 'M',
  14: 'N',
  15: 'O',
  16: 'P',
  17: 'Q',
  18: 'R',
  19: 'S',
  20: 'T',
  21: 'U',
  22: 'V',
  23: 'W',
  24: 'X',
  25: 'Y',
  26: 'Z',
};
